import client from "./client";

export const reviewing = ({ score, review }) => {
  let success = client.post("/diagnosis/api/reviewing", {
    score,
    review,
  });
  return success;
};

export const duplicateCheck = () =>
  client.get("/diagnosis/api/reviewing/duplicate-check");
